export const shortenCommitHash = (hash: string) => hash.slice(0, 8)
